module.exports = __webpack_public_path__ + "img/juxueIcon3.0fffd856.png";